import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PillButtonContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    onClick,
    testId = TEST_ID
}) => (
    <button
        className={`${className} ${styles.pillButtonContainer}`}
        data-testid={testId}
        onClick={onClick}>
        {children}
    </button>
);

export default PillButtonContainer;
